/* tslint:disable */
/* eslint-disable */
/**
 * Immutable X API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@immutable.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface MetadataRefreshExcludingSummary
 */
export interface MetadataRefreshExcludingSummary {
    /**
     * The collection address
     * @type {string}
     * @memberof MetadataRefreshExcludingSummary
     */
    'collection_address': string;
    /**
     * When the metadata refresh completed
     * @type {string}
     * @memberof MetadataRefreshExcludingSummary
     */
    'completed_at'?: string | null;
    /**
     * The metadata refresh ID
     * @type {string}
     * @memberof MetadataRefreshExcludingSummary
     */
    'refresh_id': string;
    /**
     * When the metadata refresh started
     * @type {string}
     * @memberof MetadataRefreshExcludingSummary
     */
    'started_at': string;
    /**
     * The metadata refresh status
     * @type {string}
     * @memberof MetadataRefreshExcludingSummary
     */
    'status': MetadataRefreshExcludingSummaryStatusEnum;
}

export const MetadataRefreshExcludingSummaryStatusEnum = {
    Queued: 'queued',
    InProgress: 'in_progress',
    Completed: 'completed'
} as const;

export type MetadataRefreshExcludingSummaryStatusEnum = typeof MetadataRefreshExcludingSummaryStatusEnum[keyof typeof MetadataRefreshExcludingSummaryStatusEnum];


